<template>
  <div
    class="flex flex-col m-4 hover:shadow-lg w-full"
    :class="circle_css"
    v-show="states.show"
    @dragenter="!isLocked && triggerHoverState()"
  >
    <a
      href="#"
      class="no-underline overflow-hidden relative"
      :class="isLocked ? 'text-grey-dark bg-grey-light cursor-pointer' : 'text-grey-darkest bg-brand-lightest'"
      @click.prevent="handleVaultClick()"
    >
      <!-- Locked vault -->
      <div
        v-if="isLocked"
        class="w-full flex flex-col justify-center items-center p-2 h-40 bg-grey-light"
      >
        <i class="fa fa-lock text-grey-dark text-2xl mb-1"></i>
        <span class="text-lg font-medium text-center text-grey-dark">{{ vault.name }}</span>
        <span class="text-xs text-grey-dark text-center mt-1 px-2">
          Click to update payment details and unlock the Vault
        </span>
      </div>
      <!-- Unlocked vault -->
      <template v-else>
      <div
        class="vault-info text-left flex flex-wrap h-40 content-between"
        v-if="pluploader_object != undefined && pluploader_object.files == 0"
      >
        <div
          class="
            w-full
            flex flex-col
            justify-center
            items-center
            h-24
            align-center
            bg-brand-lightest
            relative
          "
          v-if="pluploader_object != undefined && pluploader_object.files == 0"
        >
          <div
            class="bg-red text-white self-start text-xs absolute p-1 top-0"
            v-if="vault.storage_exceeded"
          >
            <i class="fa fa-exclamation-triangle"></i> Vault Storage Exceeded
          </div>
          <div class="bg-vault-icon"></div>
          <span class="text-lg font-medium text-center">{{ vault.name }}</span>
          <span class="text-xs text-red text-center" v-if="vault.pivot && vault.pivot.expires_at">{{ expiresAt }}</span>
          <span class="text-xxs text-grey-dark text-center" v-if="vault.storage_exceeded"
            >{{ rounded }} MB / {{ vault.max_storage_in_megabytes }} GB</span
          >
        </div>
        <vault-stats
          v-if="stats"
          :vaultStats="stats"
          :vault-id="vault.id"
          :vault="vault"
          class="w-full"
        ></vault-stats>
      </div>
      <div
        class="uploaded_files w-3/4"
        v-if="pluploader_object != undefined && pluploader_object.files != 0"
      >
        <p class="font-medium tracking-wide text-center">
          Uploading to {{ vault.name }}
        </p>
        <p class="text-sm text-center py-2">
          {{ uploader.files_uploaded }} / {{ uploader.files_total }}
        </p>
        <ul class="text-center">
          <li
            v-for="file in pluploader_object.files"
            :key="file.id"
            class="list-progress animated"
            :class="{ fadeOutUp: file.percent == 100 }"
          >
            <vue-simple-progress
              size="medium"
              :val="file.percent"
              :text="cutFilename(file.name)"
            ></vue-simple-progress>
          </li>
        </ul>
      </div>
      </template>
    </a>

    <div
      v-if="!isLocked"
      class="
        flex flex-col
        justify-center
        items-center
        text-white
        bg-grey-darkest
        opacity-75
        absolute
      "
      :class="{ invisible: !states.hovered }"
      @dragleave="triggerHoverOutState"
      ref="drop_target"
    >
      Drop files here to upload
    </div>

    <sweet-modal icon="warning" ref="upload_not_available" overlay-theme="dark"
      >You are not authorized to upload a file</sweet-modal
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueSimpleProgress from "vue-simple-progress";
import VaultStats from "./VaultStats";
import moment from 'moment';

export default {
  components: { VueSimpleProgress, VaultStats },

  props: ["vault", "stats"],

  data() {
    return {
      notifications: "",

      pluploader_object: null,
      uploader: {
        current_percent: 0,
        files_uploaded: 0,
        files_total: 0,
      },

      unfiled: 0,
      uploading_to_s3: false,
      uploaded_to_s3: false,

      states: {
        hovered: false,
        show: true,
      },
    };
  },

  mounted() {
    if (!this.isLocked) this.initializeUploader();

    axios
      .get("/api/vaults/" + this.vault.id + "/files/for-tagging", {
        params: {
          mine_only: 1,
        },
      })
      .then(({ data }) => {
        this.unfiled = data.total;
      });
  },

  computed: {
    isLocked() {
      return this.vault.subscription_id == null || this.vault.subscription_id === "";
    },
    circle_css() {
      let css_class = [];
      if (this.isLocked) {
        css_class.push("border-2 border-grey");
      } else if (this.states.hovered) {
        css_class.push("shadow-lg border-2 border-grey");
      } else {
        css_class.push("border-2 border-brand");
      }
      return css_class;
    },
    ...mapGetters({
      user: "getUser",
      role: "getUserRole",
    }),
    rounded() {
      return _.floor(this.vault.total_size_in_megabytes, 2);
    },

    expiresAt() {
      if(this.vault.pivot && this.vault.pivot.expires_at) {
        return 'Access expires ' + moment(this.vault.pivot.expires_at, 'YYYY-MM-DD hh:mm:ss').format('Do MMMM hh:mma');
      }
      return '';
    }
  },

  methods: {
    handleVaultClick() {
      if (this.isLocked) {
        this.$router.push({
          name: "update-billing-details",
          params: { vault_id: this.vault.id },
        });
        return;
      }
      this.selectAsCurrentVault();
    },
    selectAsCurrentVault() {
      this.$store.commit("setCurrentVault", this.vault.id);
      axios.get(`/api/vaults/${this.vault.id}/my-role`).then(({ data }) => {
        if (data) {
          this.$store.commit("setUserRole", data);

          this.$authorize
            .isAuthorized(
              [this.role],
              ["can_file_document", "can_tag_document"]
            )
            .then(() => {
              this.$router
                .push({
                  name: "dashboard",
                  params: { vault_id: this.vault.id },
                })
                .catch((err) => {
                  if (err.name != "NavigationDuplicated") {
                    throw err;
                  }
                });
              this.$ebus.$emit("get-categorized-tags");
            })
            .catch(() => {
              this.$router
                .push({
                  name: "search-documents",
                  params: { vault_id: this.vault.id },
                })
                .catch((err) => {
                  if (err.name != "NavigationDuplicated") {
                    throw err;
                  }
                });
              this.$ebus.$emit("get-categorized-tags");
            });
        }
      });
    },
    cutFilename(filename) {
      let new_name = "";
      new_name = filename.substring(0, 20) + "...";
      return new_name;
    },
    toggleVisibility(toggle) {
      this.states.show = toggle == "show" ? true : false;
    },
    triggerHoverState() {
      this.states.hovered = true;
    },
    triggerHoverOutState() {
      this.states.hovered = false;
    },
    updateUploadStatus(up) {
      this.uploader.files_uploaded = up.total.uploaded;
      this.uploader.files_total = up.files.length;
    },
    initializeUploader() {
      this.uploader.files_uploaded = 0;
      this.uploader.files_total = 0;

      this.pluploader_object = new plupload.Uploader({
        drop_element: this.$refs.drop_target,
        url: `/api/vaults/${this.vault.id}/files/upload`,
        chunk_size: "50mb",
        multi_selection: false,
        multipart_params: {
          _token: Laravel.csrfToken,
        },
      });

      this.pluploader_object.bind("FileUploaded", (up, file, data) => {
        this.updateUploadStatus(up);
      });

      this.pluploader_object.bind("Error", (up, err) => {
        this.updateUploadStatus(up);
        _.delay(() => {
          this.initializeUploader();
        }, 2000);
      });

      this.pluploader_object.bind("UploadComplete", (up, files) => {
        this.updateUploadStatus(up);
        _.delay(() => {
          this.initializeUploader();
          this.$ebus.$emit("refresh-vaults");
        }, 2000);
      });

      this.pluploader_object.bind("FilesAdded", (up, files) => {
        // get user role first before adding the file
        this.checkVaultUserRole().then((role) => {
          this.$authorize
            .isAuthorized([role], ["can_upload"])
            .then(() => {
              if (this.vault.storage_exceeded) {
                this.$noty.error(
                  "File Storage exceeded, uploading is not allowed"
                );
                this.triggerHoverOutState();
                this.pluploader_object.splice();
              } else {
                this.uploader.files_total = up.files.length;
                this.triggerHoverOutState();
                this.pluploader_object.start();
              }
            })
            .catch(() => {
              this.initializeUploader();
              this.triggerHoverOutState();
              this.$refs.upload_not_available.open();
            });
        });
      });

      this.pluploader_object.init();
    },

    checkVaultUserRole() {
      return axios
        .get(`/api/vaults/${this.vault.id}/my-role`)
        .then(({ data }) => {
          if (data) {
            let vault_id = this.vault.id;
            let role_name = data.name;
            let replace_char = vault_id + "-";

            let role = _.camelCase(role_name.replace(replace_char, ""));

            return role;
          }
        });
    },
  },
};
</script>

<style>
.list-progress {
  -moz-animation-duration: 1s;
  -webkit-animation-duration: 1s;
  -moz-animation-delay: 1s;
  -webkit-animation-delay: 1s;
}

.bg-vault-icon {
  /* background: url("/images/vaults-list-img.png") center center no-repeat; */
  position: absolute;
  opacity: 0.2;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>
